export default __webpack_public_path__ + "static/media/co_foreign_front.366887b5.jpeg";